<template>
  <div>
    <Head title="Energy Managers" />
    <span class="group flex items-center py-3 mb-6">
      <icon name="users" class="mr-4 w-8 h-8 text-gray-700"/>
      <h1 class="text-3xl font-bold">List of Registered Energy Manager ( total : {{ managersTotal }})</h1>
    </span> 

    <br />

    <!-- <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search_manager" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed_manager" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
    </div> -->

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Name</th>
            <th class="pb-4 pt-6 px-6">Certificate No..</th>
            <th class="pb-4 pt-6 px-6">Telephone Number</th>
            <th class="pb-4 pt-6 px-6">Email</th>
            <th class="pb-4 pt-6 px-6">Company</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="manager in managers.data" :key="manager.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500">
                {{ manager.name }}
                <icon v-if="manager.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4">
                {{ manager.certification }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4">
                {{ manager.phone }}
              </span>
            </td>
                        <td class="border-t">
              <span class="flex items-center px-6 py-4">
                {{ manager.email }}
              </span>
            </td>
            <td class="border-t">
              <center>
              <span class="items-center px-6 py-4">
                {{ manager.company_name }}
              </span>
            </center>
            </td>
          </tr>
          <tr v-if="managers.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="5">
              <span class="flex justify-center py-2">
                    <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                    No registrations found..&nbsp;&nbsp;
              </span>  
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="managers.links" />

  </div>

  <div class="mt-10">

    <span class="group flex items-center py-3 mb-6">
      <icon name="esco" class="mr-4 w-8 h-8 text-gray-700"/>
      <h1 class="text-3xl font-bold">List of Registered EESCO ( total : {{ companiesTotal }})</h1>
    </span>

    <!-- <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search_companies" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed_companies" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
    </div> -->

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Company Name</th>
            <th class="pb-4 pt-6 px-6">ROC</th>
            <th class="pb-4 pt-6 px-6">Telephone Number</th>
            <th class="pb-4 pt-6 px-6">Email</th>
            <th class="pb-4 pt-6 px-6">Approval Date</th>
            <th class="pb-4 pt-6 px-6">Expiry Date</th>
            <th class="pb-4 pt-6 px-6">Competent Person</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="companies in companies.data" :key="companies.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500">
                {{ companies.company_name }}
                <icon v-if="companies.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4">
                {{ companies.registration_no }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4">
                {{ companies.phone }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4">
                {{ companies.email }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4">
                {{ companies.approval }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4">
                {{ companies.expiry }}
              </span>
            </td>
            <td class="border-t"> 
              <span v-for="(competent, index) in companies.competents" :key="index" class="flex items-center px-6 py-4">
                {{ competent.name }}
              </span>
            </td>          </tr>
          <tr v-if="companies.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">
              <span class="flex justify-center py-2">
                    <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                    No companies found..&nbsp;&nbsp;
              </span>  
            </td>
          </tr>
        </tbody>
      </table>
    <pagination class="mt-6" :links="companies.links" />

  </div>

</div>

</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import { ref } from "vue";
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    managerFilters: Object,
    companyFilters: Object,
    feedbacks: Object,
    managers: Object,
    companies: Object,
    managersTotal: Object,
    companiesTotal: Object,
  },
  data() {
    return {
      form: {
        search_manager: this.managerFilters.search_manager || '',
        trashed_manager: this.managerFilters.trashed_manager || '',
        search_companies: this.companyFilters.search_companies || '',
        trashed_companies: this.companyFilters.trashed_companies || '',
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/listings', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  mounted(){ 
   console.log(this.companies)
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    loadFeedbacks(){
      this.toggleModal()
    },
    passPhotoUploaded(passport_info){
      return (!passport_info)?false:true; 
    },
    loadPassPhoto(passport_info){
      return passport_info.attachment 
    },
  },
}
</script>
